(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Example", [], factory);
	else if(typeof exports === 'object')
		exports["Example"] = factory();
	else
		root["Example"] = factory();
})(window, function() {
return 